var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 9.125v-1.75a4.375 4.375 0 1 1 8.75 0v1.75c.966 0 1.75.784 1.75 1.75v4.375a1.75 1.75 0 0 1-1.75 1.75h-8.75a1.75 1.75 0 0 1-1.75-1.75v-4.375c0-.966.784-1.75 1.75-1.75Zm7-1.75v1.75h-5.25v-1.75a2.625 2.625 0 1 1 5.25 0Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.0b4b9f0d46918576930752687d761848.svg";
export { ForwardRef as ReactComponent };